import { createFileRoute } from '@tanstack/react-router'
import { ScBillingPage } from '@/features/support-coordination/billing'

export const Route = createFileRoute(
  '/_authenticated/_organization/support-coordination/billing',
)({
  component: ScBillingPage,
})
